export default __webpack_public_path__ + "static/media/resume.3f296d75.pdf";